// extracted by extract-css-chunks-webpack-plugin
module.exports = {"menuPanel":"profilepanel__menuPanel","mobile":"profilepanel__mobile","mobileClose":"profilepanel__mobileClose","divider":"profilepanel__divider"};